import ContactFloatingButton from './ContactFloatingButton'

export default function SkillsWeb() {
  return (
    <div>
      <div className='container mx-auto bg-sk-white max-md:px-20'>
        {/* 웹 - 어떤 기기로 확인해도 */}
        <div className='flex items-start justify-between py-48 sm:py-64 sm:items-center max-sm:flex-col sm:flex max-sm:gap-12'>
          <div className='flex flex-col items-start gap-6'>
            <p className='text-h2-medium sm:text-h1-medium text-sk-info'>웹</p>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-default'>
              어떤 기기로 확인해도 같은 서비스를 제공받을 수 있도록
              <br />
              반응형을 기본으로 제작합니다
            </p>
          </div>
          <p className='text-body1-long-medium text-sk-sub'>
            반응형은 기본! 자연스러운 모션까지 <br />
            템플릿에서 만나볼 수 없는 디테일을 만나보세요
          </p>
        </div>
        {/* 비디오 */}
        <div className='container mx-auto py-60 sm:py-80 bg-sk-white mb-[-220px] sm:mb-[-260px]'>
          <div className='flex items-center justify-center max-sm:flex-col gap-60 sm:gap-120'>
            <video
              className='sm:size-1/2'
              poster={require('assets/images/skills-web-video-thumbnail.png')}
              preload='none'
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={require('assets/videos/skills-web_video.webm')} />
              <source src={require('assets/videos/skills-web_video.mp4')} />
            </video>
            <div className='flex flex-col items-start gap-24'>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                다양한 모션 지원으로 <br />
                역동적인 홈페이지를 구현해 드립니다
              </p>
              <p className='text-body1-long-regular text-sk-info'>
                유용한 모션과 합리적인 운용으로
                <br />
                고객의 사용성을 높일 수 있습니다
              </p>
            </div>
          </div>
        </div>
      </div>
      <ContactFloatingButton />
    </div>
  )
}
